import { type ClaimsEvidenceReasoningFormData } from "@/types/models/Exportables.interface";

export type FieldProps = {
  label: string;
  field: keyof ClaimsEvidenceReasoningFormData;
};

export const isContextCluesFormData = (
  data: any,
): data is ClaimsEvidenceReasoningFormData => {
  return data && typeof data === "object" && "question" in data;
};

export function createFieldsData(): Array<FieldProps[]> {
  return [
    [
      {
        label: "Question: What is the phenomena or problem presented?",
        field: "question",
      },
    ],
    [
      {
        label: "Claim: What is the answer or solution to this question?",
        field: "claim",
      },
    ],
    [
      {
        label:
          "Evidence 1: What information supports the claim? What is the source?",
        field: "firstEvidence",
      },
      {
        label:
          "Evidence 2: What information supports the claim? What is the source?",
        field: "secondEvidence",
      },
    ],
    [
      {
        label:
          "Reasoning: How does the evidence support the claim? What scientific concepts did you use to make sense of the evidence?",
        field: "reasoning",
      },
    ],
  ];
}
